
	import { Component, Vue, Watch } from 'vue-property-decorator';
	import NotesModal from '@/components/modals/NotesModal.vue';
	import { autorun } from 'mobx';

	@Component({
		components: {}
	})
	export default class DesignInspectionButton extends Vue {
		private toggle = false;

		public text = '';
		public hide = false;
		public isOnscreenPreview = false;
		public hideOn = ['Get Started', '3D Scan', 'Results', 'Landmark selection', 'Order', 'Patients', 'Saved Rx List', 'Saved Rx', 'Scan settings'];
		public hideOnPaths = ['/threed', '/landmarks'];
		disposeAutorun: any;

		mounted() {
			this.disposeAutorun = autorun(() => {
				this.isOnscreenPreview = this.$state.leroy.isOnscreenPreview;
			});
		}
		beforeDestroy() {
			this.disposeAutorun();
		}

		@Watch('$route', { immediate: true, deep: true })
		onNavigation(val: any) {
			this.hide = !(this.hideOn.includes(val.name) || this.hideOnPaths.includes(val.path));
		}

		private async open() {
			this.$state.leroy.SetScene('InsoleVisualizer');
			await new Promise((r) => setTimeout(r, 2000));
			this.$state.leroy.modalVisible = true;
		}

		private cancel() {
			this.toggle = false;
		}

		private save() {
			this.$state._patient.patientUIData.notes = this.text;
			this.toggle = false;
		}
	}
